module.exports = __webpack_public_path__ + "img/nasiha_osmanovic.83fc42dc.png";